export function tryGetPlugin(editor, pluginName) {
    if (editor.plugins.has(pluginName)) {
        return editor.plugins.get(pluginName);
    }
    return undefined;
}
